export default "__VITE_ASSET__XGd0xAea__"